import {ENDPOINT_URL} from 'constants/index';
import {apiErrorHandling} from 'utils/apiUtils';
import getFetchOptions from 'utils/getFetchOptions';

export default function simulateTestResult(params) {
	return fetch(
		`${ENDPOINT_URL}/admin/simulate-test-result`,
		getFetchOptions({
			method: 'POST',
			body: JSON.stringify(params),
		})
	)
		.then((response) => {
			if (!response.ok) {
				throw response;
			}
			return response.json();
		})
		.catch((err) => {
			if (err && typeof err.text === 'function') {
				return apiErrorHandling(err).then((parsedError) =>
					Promise.reject(parsedError)
				);
			}

			return Promise.reject({
				message: (err && err.message) || 'Network request failed',
			});
		});
}
